export default (function (_ref) {
  var request = _ref.request;
  return {
    taskAdd: function taskAdd(data) {
      return request({
        url: '/grow/task/add',
        method: 'post',
        data: data
      });
    },
    taskModify: function taskModify(data) {
      return request({
        url: "/grow/task/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    taskDel: function taskDel(id) {
      return request({
        url: "/grow/task/".concat(id, "/del"),
        method: 'delete'
      });
    },
    taskHandle: function taskHandle(handleId, data) {
      return request({
        url: "/grow/task/".concat(handleId, "/handle"),
        method: 'post',
        data: data
      });
    },
    taskQuery: function taskQuery(data) {
      return request({
        url: '/grow/task/query',
        method: 'get',
        params: data
      });
    },
    taskDetail: function taskDetail(id) {
      return request({
        url: "/grow/task/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});